import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { SelectedableElement as AnnotationDisplay } from 'constants/feature/element-panel-constants';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

const ANNOTATION_DETAILS_BLOCK = 'annotation-details';

const AnnotationDetails = ({ className, isCftEnabled }) => {
  const { elementDetails, comfortLetterList } = useSelector(
    (state) => state.data.elementPanel,
  );

  const [comfortLettersList, setComfortLettersList] = useState(
    comfortLetterList.comfortLetters,
  );

  useEffect(() => {
    setComfortLettersList(comfortLetterList.comfortLetters);
  }, [comfortLetterList.comfortLetters]);

  if (elementDetails.isLoaded === false) {
    return null;
  }

  return (
    <div
      className={classnames(ANNOTATION_DETAILS_BLOCK, className)}
      id="element-annotation-details"
    >
      <AnnotationDisplay
        elementDetails={elementDetails}
        comfortLettersList={comfortLettersList}
        isCftEnabled={isCftEnabled}
      />
    </div>
  );
};

AnnotationDetails.protoTypes = {
  /** parent className */
  className: PropTypes.string,
  /** boolean based on comfort letter is enabled from statement level */
  isCftEnabled: PropTypes.bool,
};

export default AnnotationDetails;
